import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _EditBankModal;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import { toErrors } from '../../../common/util/instUIMessages';
import { Modal, ModalHeader, ModalBody, ModalFooter, TextInput, XSMALL_SIDE_MARGIN } from '@instructure/quiz-common';
import Bank from '../../../common/records/Bank';
export var EditBankModal = /*#__PURE__*/function (_Component) {
  function EditBankModal(props) {
    var _this2;
    _classCallCheck(this, EditBankModal);
    _this2 = _callSuper(this, EditBankModal, [props]);
    _defineProperty(_this2, "continueAction", function () {
      _this2.props.showError(_this2.props.errorKey);
      if (_this2.props.workingBank.isValid()) {
        _this2.props.updateBank(_this2.props.workingBank);
        _this2.closeAction();
      } else {
        var _this2$bankNameInput$;
        (_this2$bankNameInput$ = _this2.bankNameInput.current) === null || _this2$bankNameInput$ === void 0 || _this2$bankNameInput$.focus();
      }
    });
    _defineProperty(_this2, "closeAction", function () {
      _this2.props.hideError(_this2.props.errorKey);
      _this2.props.clearModifications('banks', _this2.props.workingBank.id);
      if (_this2.props.modalTrigger) {
        _this2.props.modalTrigger.focus();
      }
      _this2.props.closeModal();
    });
    _defineProperty(_this2, "onNameChange", function (e) {
      _this2.props.showError(_this2.props.errorKey);
      _this2.props.changeBank(_this2.props.workingBank.id, {
        title: e.target.value
      });
    });
    _defineProperty(_this2, "getErrors", function () {
      if (_this2.props.displayError) {
        return toErrors(_this2.props.workingBank.errorsFor('title').toJS());
      }
    });
    _this2.bankNameInput = React.createRef();
    return _this2;
  }
  _inherits(EditBankModal, _Component);
  return _createClass(EditBankModal, [{
    key: "renderCancelButton",
    value: function renderCancelButton() {
      return jsx(Button, {
        onClick: this.closeAction,
        margin: XSMALL_SIDE_MARGIN
      }, t('Cancel'));
    }
  }, {
    key: "renderSaveButton",
    value: function renderSaveButton() {
      return jsx(Button, {
        type: "button",
        color: "primary",
        onClick: this.continueAction,
        margin: XSMALL_SIDE_MARGIN,
        "data-automation": "sdk-edit-bank-save-button"
      }, t('Save Changes'));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return jsx(TextInput, {
        value: this.props.workingBank.title,
        messages: this.getErrors(),
        onChange: this.onNameChange,
        renderLabel: t('Bank Name'),
        type: "text",
        isRequired: true,
        "data-automation": "sdk-edit-bank-name-textinput",
        ref: this.bankNameInput
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Modal, {
        open: this.props.modalOpen,
        onDismiss: this.closeAction,
        size: "small",
        label: t('Item Bank'),
        "data-automation": "sdk-edit-bank-modal"
      }, jsx(ModalHeader, null, jsx(Heading, {
        as: "h2"
      }, t('Edit Item Bank')), jsx(CloseButton, {
        onClick: this.closeAction,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), jsx(ModalBody, null, this.renderContent()), jsx(ModalFooter, null, this.renderCancelButton(), this.renderSaveButton()));
    }
  }]);
}(Component);
_EditBankModal = EditBankModal;
_defineProperty(EditBankModal, "displayName", 'EditBankModal');
_defineProperty(EditBankModal, "componentId", "Quizzes".concat(_EditBankModal.displayName));
_defineProperty(EditBankModal, "propTypes", {
  modalOpen: PropTypes.bool.isRequired,
  modalTrigger: PropTypes.instanceOf(Component),
  workingBank: PropTypes.instanceOf(Bank).isRequired,
  displayError: PropTypes.bool,
  errorKey: PropTypes.string.isRequired,
  updateBank: PropTypes.func.isRequired,
  changeBank: PropTypes.func.isRequired,
  clearModifications: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
  hideError: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  styles: PropTypes.object
});
_defineProperty(EditBankModal, "defaultProps", {
  displayError: false,
  modalTrigger: null
});
export default EditBankModal;